<template>
    <div id="status">
      <v-container>
        <table>
          <tr v-for="(server, index) in serverStatuses" :key=index >
            <td><b class="mr-4">{{ server.name }}</b></td>
            <td><p class="mb-0">{{ server.status }}</p></td>
          </tr>
        </table>
      </v-container>
    </div>
</template>
<script>
export default {
    props: {
      front: {
        type: [String, Boolean],
        required: true
      },
      middle: {
        type: [String, Boolean],
        required: true
      },
      docxAPI: {
        type: [String, Boolean],
        required: true
      },
      s3: {
        type: [String, Boolean],
        required: false
      },
      database: {
        type: [String, Boolean],
        required: true
      }
    },
    data: () => ({
        statusTypes: {
          upMessage: "Up",
          downMessage: "Down",
          unknownMessage: "Unknown"
        },
        serverStatuses: {
          frontEnd: {
            name: "Front",
            status: ""
          },
          middleTier: {
            name: "Middle",
            status: ""
          },
          s3: {
            name: "S3",
            status: ""
          },
          database: {
            name: "Database",
            status: ""
          },
          docxAPI: {
            name: "DocX API",
            status: ""
          }
        }
        
    }),
    
    created () {
      this.setStatus();
    },
    
    methods: {
      setStatus () {
        if(typeof this.front !== 'string' && this.front === true){
          this.serverStatuses.frontEnd.status = this.statusTypes.upMessage;
        } else if (typeof this.front !== 'string' && this.front === false) {
          this.serverStatuses.frontEnd.status = this.statusTypes.downMessage;
        } else {
          this.serverStatuses.frontEnd.status = this.statusTypes.unknownMessage;
        }
        
        if(typeof this.middle !== 'string' && this.middle === true){
          this.serverStatuses.middleTier.status = this.statusTypes.upMessage;
        } else if (typeof this.middle !== 'string' && this.middle === false) {
          this.serverStatuses.middleTier.status = this.statusTypes.downMessage;
        } else {
          this.serverStatuses.middleTier.status = this.statusTypes.unknownMessage;
        }
        
        if(typeof this.docxAPI !== 'string' && this.docxAPI === true){
          this.serverStatuses.docxAPI.status = this.statusTypes.upMessage;
        } else if (typeof this.docxAPI !== 'string' && this.docxAPI === false) {
          this.serverStatuses.docxAPI.status = this.statusTypes.downMessage;
        } else {
          this.serverStatuses.docxAPI.status = this.statusTypes.unknownMessage;
        }

	this.serverStatuses.s3.status = this.statusTypes.unknownMessage;
        
        if(typeof this.database !== 'string' && this.database === true){
          this.serverStatuses.database.status = this.statusTypes.upMessage;
        } else if (typeof this.database !== 'string' && this.database === false) {
          this.serverStatuses.database.status = this.statusTypes.downMessage;
        } else {
          this.serverStatuses.database.status = this.statusTypes.unknownMessage;
        }
        
      }
    },
}
</script>
<style type="text/css" scoped>
  table tr {
    border-bottom: 1px solid black;
  }
  
  table tr:last-child {
    border-bottom: none;
  }
  
  
</style>
